import {Component, OnChanges, OnInit, Input, SimpleChanges, AfterViewInit} from '@angular/core';
import {DeploymentsService, GliderGroup} from "../deployments.service";
import * as $ from 'jquery';
import * as moment from 'moment';
import {NgxSpinnerService} from "ngx-spinner";
import {NamedRoutesService} from "ng-named-routes";
import {TimezoneService} from "../timezone.service";
import * as appGlobals from 'globals';
import {stringify} from "querystring";
import {stringLiteral} from "@babel/types";

@Component({
    selector: 'app-deployments-view',
    templateUrl: './deployments-view.component.html',
    styleUrls: ['../deployments/deployments.component.scss']
})
export class DeploymentsViewComponent implements OnInit, OnChanges {

    @Input('glider-groups') gliderGroups: GliderGroup[] = [];
    @Input('show-filters') showFilters;
    @Input('filter-options') filterOptions;
    @Input() selected;
    @Input() highlighted;
    @Input('deployment-numbers') deploymentNumbers;
    @Input('map-subtext') mapSubtext;
    @Input('map-id') mapId;

    FILTER_ALL_DEPLOYMENTS = 'All';
    FILTER_ALL_TYPES = 'All Glider Types';
    FILTER_ALL_PLATFORMS = 'All Glider Names';
    FILTER_ALL_REGIONS = 'All Regions';

    filteredDeployments: GliderGroup[] = [];
    selectedDeployment: any = null;
    highlightedDeployment: null;
    filterCollapsed = false;
    sortColumn = '-deployment_number';
    gliderTypeOptions = [this.FILTER_ALL_TYPES, 'Slocum', 'Wave'];
    platformOptions:any[] = [];
    regionOptions: any[] = [];
    whichDeployments = [this.FILTER_ALL_DEPLOYMENTS, 'Current'];
    filter: any = null;
    moment = moment;
    timezone: any = null;
    mapTitle: any = null;
    isCoordinatesLoaded: boolean;
    partialLoad: boolean = true;

    constructor(
        private deploymentsService: DeploymentsService,
        private spinner: NgxSpinnerService,
        private timezoneService: TimezoneService,
        private namedRoutesService: NamedRoutesService
    ) {
        this.timezone = timezoneService.timezone;
        this.resetFilter();
        if (appGlobals.isMobile) {
            this.filterCollapsed = true;
        }
    }

    getRoute(): string {
        return '/' + this.namedRoutesService.getRoute.apply(this.namedRoutesService, arguments);
    }

    ngOnChanges(): void {
        if (this.gliderGroups.length) {
            this.filteredDeployments = this.gliderGroups.filter(group => this.isMissionIncluded(group));
            //this.filteredDeployments.sort((a, b) => b['deployment_number'] - a['deployment_number']);
            this.sortBy(this.sortColumn);
        }

        if (this.filter.deployments == 'Current') {
            this.mapTitle = 'Current Deployments';
        } else {
            this.mapTitle = 'All Deployments';
            if(this.partialLoad && this.gliderGroups.length) {
                this.deploymentNumbers = undefined;
                this.isCoordinatesLoaded = false;
                this.initDeployments();
                this.partialLoad = false;
            }
        }
    }

    ngOnInit() {
        this.resetFilter();
        this.initDeployments();
    }

    initDeployments() {
        this.spinner.show('spinner-glider-map');
        setTimeout(() => {
            // While ngx-spinner supports multiple, for some reason including table causes map spinner to not work
            this.spinner.show('spinner-glider-table');
        }, 1);

        const vm = this; // Allows using 'this' in nested functions without possible errors
        this.deploymentsService.getDeployments(this.deploymentNumbers).then((response: Array<any>) => {
            const gliderGroups = response;
            const ids = gliderGroups.map(m => m.deployment_number);
            vm.gliderGroups = gliderGroups;

            const gliderNames = this.gliderGroups.map(group => group.platform_name);
            const regionNames = this.gliderGroups.map(group => group.sea_name);

            this.platformOptions = [this.FILTER_ALL_PLATFORMS].concat(Array.unique(gliderNames, 0));
            let filteredRegionNames = this.splitMultipleRegions(regionNames);
            this.regionOptions = [this.FILTER_ALL_REGIONS].concat(filteredRegionNames);

            vm.filteredDeployments = vm.gliderGroups.filter(group => this.isMissionIncluded(group));
            this.sortBy(this.sortColumn);

            vm.deploymentsService.getMissionSurfaceStatus().then(function (result) {
                const ids = Object.keys(result);
                ids.forEach(function (id) {
                    // @ts-ignore
                    const index = Array.indexOfByProperty(gliderGroups, parseInt(id), 'deployment_number');
                    if (index >= 0) {
                        const the_result = result[id];
                        if (Object.keys(the_result).length) {
                            vm.gliderGroups[index].status_info = the_result
                        }
                    }
                });
                vm.deploymentsService.getMissionsCoordinates(null).then(function (result) {
                    const ids = Object.keys(result);
                    ids.forEach(function (id) {
                        // @ts-ignore
                        const index = Array.indexOfByProperty(gliderGroups, parseInt(id), 'deployment_number');
                        if (index >= 0) {
                            gliderGroups[index].info = result[id];
                            gliderGroups[index].travel_distance = result[id]["distance"];
                            if (gliderGroups[index].status_info) {
                                const last_coordinate = {
                                    lat: gliderGroups[index].status_info.status.current.gps_lat,
                                    lng: gliderGroups[index].status_info.status.current.gps_lon
                                };
                                gliderGroups[index].info.coordinates.push(last_coordinate);
                                gliderGroups[index].info.lastCoordinates = last_coordinate;
                            }
                        }
                    });

                    vm.spinner.hide('spinner-glider-map');
                    vm.spinner.hide('spinner-glider-table');
                    vm.isCoordinatesLoaded = true;
                });
            });

            this.deploymentsService.getKmlPaths(vm.gliderGroups).then(response => {
                vm.gliderGroups.forEach(function (group) {
                    const kmlInfo = response.kmlPaths['numberedMissions'][group.deployment_number];
                    const kmlInfoOld = response.kmlPathsOld['numberedMissions'][group.deployment_number];
                    if (kmlInfo) {
                        group.kmlUrl = kmlInfo.fullUrl;
                    }
                    if (kmlInfoOld) {
                        group.kmlUrlOld = kmlInfoOld.fullUrl;
                    }
                });
            });

            this.deploymentsService.getPlotThumbnailPaths().then(response => {
                vm.gliderGroups.forEach(function (group) {
                    group.hasPlotThumbnails = !!response[group.deployment_number];
                });
            });

            this.deploymentsService.getMetadata().then(response => {
                vm.gliderGroups.forEach(function (group) {
                    group.hasErddapSet = !!(response[group.deployment_number] && response[group.deployment_number].variables);
                });
            });
        });
        // this re-calculated filteredDeployments
        //vm.filteredDeployments = vm.gliderGroups.filter(group => vm.isMissionIncluded(group));
        //vm.sortBy(vm.sortColumn);
        vm.filteredDeployments = [];
    }

    sortBy(name: string): void {
        this.sortColumn = name;
        let reverse = false;
        if (name[0] == '-') {
            reverse = true;
            name = name.slice(1);
        }
        let compareFunction;
        if (reverse) {
            compareFunction = (a, b) => eval('a.' +  name + ' > b.' + name + ' ? -1 : 1');
        } else {
            compareFunction = (a, b) => eval('b.' +  name + ' > a.' + name + ' ? -1 : 1');
        }
        this.filteredDeployments.sort(compareFunction);
    }

    splitMultipleRegions(regionNames: string[]) : any[]{

        var uniqueRegionNames = Array.unique(regionNames, 0);
        var splitRegionNames:any[] = [];
        var filteredRegions:any[] = [];

        for(let i=0;i<uniqueRegionNames.length;i++) {

            if (uniqueRegionNames[i].includes(',')) {
                splitRegionNames = uniqueRegionNames[i].split(',');
                filteredRegions = filteredRegions.concat(splitRegionNames);
            }
            else if (uniqueRegionNames[i].includes('\n')){
                splitRegionNames = uniqueRegionNames[i].split('\n');
                filteredRegions = filteredRegions.concat(splitRegionNames);
            }
            else {
                filteredRegions.push(uniqueRegionNames[i].trim());
            }
        }
        for (let j=0;j<filteredRegions.length;j++) {
            filteredRegions[j] = filteredRegions[j].trim();
        }
        let returnRegionNames = Array.unique(filteredRegions, 0);
        return returnRegionNames;
    }

    resetFilter(){
        this.filter = Object.assign({
            deployments: this.FILTER_ALL_DEPLOYMENTS,
            gliderType: this.FILTER_ALL_TYPES,
            platform: this.FILTER_ALL_PLATFORMS,
            region: this.FILTER_ALL_REGIONS
        }, this.filterOptions);
    }

    isMissionIncluded(mission) {
        if (this.filter.deployments == 'Current') {
            if (mission.end_time) {
                return false;
            }
        }
        if (this.filter.gliderType !== this.FILTER_ALL_TYPES) {
            if (!this.filter.gliderType.equalsIgnoreCase(mission.glider_type)) {
                return false;
            }
        }
        if (this.filter.platform != this.FILTER_ALL_PLATFORMS) {
            if (!mission.platform_name.equalsIgnoreCase(this.filter.platform)) {
                return false;
            }
        }
        if (this.filter.region != this.FILTER_ALL_REGIONS) {
            if (!mission.sea_name.includes(this.filter.region.toString())) {
                return false;
            }
        }
        return true;
    }

    setSelectedDeployment(event, deploymentNumber) {
        this.selectedDeployment = deploymentNumber;
    }

    scrollSelectionsIntoView() {
        if (this.selectedDeployment) {
            const $el = $('#table-deployments-' + this.selectedDeployment);
            const $table = $('.deployments-view .scroll-wrapper');

            const elTop = $el.offset()!.top;
            const tableTop = $table.offset()!.top;

            $table[0].scrollTop = $table[0].scrollTop + elTop - tableTop;
        }
    }

}
